import { apiGet, apiPatch, apiPost } from "./apiClient";

export const leadsService = {
  list,
  getQueue: list,
  get,
  getLead: get,
  updateDraft,
  generateReply,
  send,
  reviewAndSend: send,
  dismiss,
  insertGmail,
  insertIntoGmail: insertGmail,
  processRecentMailbox,
  getBulkTaskProgress,
  listBulkEmailTasks,
  getBulkTaskInsights,
  getMailboxAuditResults,
};

function list({ mailbox = "", brand = "" } = {}) {
  const params = new URLSearchParams();
  if (mailbox) {
    params.set("mailbox", mailbox);
  }
  if (brand) {
    params.set("brand", brand);
  }
  const q = params.toString();
  return apiGet(q ? `/api/v1/leads/?${q}` : `/api/v1/leads/`);
}

function get(leadHash) {
  return apiGet(`/api/v1/leads/${leadHash}/`);
}

function updateDraft(leadHash, draftReply) {
  return apiPatch(`/api/v1/leads/${leadHash}/`, { draft_reply: draftReply });
}

function generateReply(leadHash, { tone, custom_instructions, reply_length } = {}) {
  const payload = {};
  if (tone != null && tone !== "") {
    payload.tone = tone;
  }
  if (reply_length != null && reply_length !== "") {
    payload.reply_length = reply_length;
  }
  if (custom_instructions != null && String(custom_instructions).trim() !== "") {
    payload.custom_instructions = String(custom_instructions).trim();
  }
  return apiPost(`/api/v1/leads/${leadHash}/generate-reply/`, payload);
}

function send(leadHash, draftReply) {
  return apiPost(`/api/v1/leads/${leadHash}/review-send/`, { draft_reply: draftReply ?? "" });
}

function dismiss(leadHash) {
  return apiPost(`/api/v1/leads/${leadHash}/dismiss/`, {});
}

function insertGmail(leadHash) {
  return apiPost(`/api/v1/leads/${leadHash}/insert-gmail/`, {});
}

function processRecentMailbox(mailboxHash) {
  return apiPost(`/api/v1/mailbox/${mailboxHash}/process-recent/`, {});
}

function getBulkTaskProgress(taskHash) {
  return apiGet(`/api/v1/bulk-email-tasks/${taskHash}/progress/`);
}

function listBulkEmailTasks() {
  return apiGet(`/api/v1/bulk-email-tasks/`).then((data) =>
    Array.isArray(data) ? data : data?.results ?? [],
  );
}

function getMailboxAuditResults(mailboxHash, range = "all") {
  const params = new URLSearchParams();
  params.set("range", range || "all");
  return apiGet(`/api/v1/mailbox/${mailboxHash}/audit-results/?${params.toString()}`);
}

function getBulkTaskInsights(taskHash) {
  return apiGet(`/api/v1/bulk-email-tasks/${taskHash}/insights/`);
}
